module.exports = __webpack_public_path__ + "static/section-2-creator-r-0df7558377c805ba20e8a8408e229f3b.png";